import { AttributeFeatureType } from './../types/project-config';
import { IO } from 'app/model/IO';
import { ProjectSaveParams } from './../components/dialogs/project-save-dialog/project-save-entry.component';
import { IDManager, IDKeyTypes } from './id-manager';
import { ConfigAttribute, AttributeOption } from 'app/types/project-config';
import { ProjectConfig, SupplementalAttribute, AvailCriteria } from 'app/types/project-config';
import { AES } from 'crypto-js';
import { ComparisonKeys } from './comparisons';
export type ConfigOptions = {
    general?:boolean,
    supplemental?: boolean,
    presets?: boolean,
    attributes?: boolean,
    config?: ProjectConfig,
    project_id?:any
};
export class ProjectConfigUtil {
  private idMgr: IDManager;

  static EncodeConfig(params: ConfigOptions): Blob {
    const config: ProjectConfig = ProjectConfigUtil.MakeEmptyConfig();
    if (params.attributes) {
      if (params.config?.attributes?.point) {
        config.attributes.point = params.config.attributes.point;
      }
      if (params.config?.attributes?.segment) {
        config.attributes.segment = params.config.attributes.segment;
      }
    }
    if (params.supplemental) {
      if (params.config?.attributes?.suppl) {
        config.attributes.suppl = params.config.attributes.suppl;
      }
    }
    return IO.EncodeData(config, true) as Blob;
  }
  static DecodeConfig(config: string): ProjectConfig | undefined {
    const key: string = config.substring(0, 32);
    config = config.substring(32);
    config = AES.decrypt(config, key).toString(CryptoJS.enc.Utf8);
    if (config) {
      return JSON.parse(config);
    }
    return undefined;
  }
  static MakeEmptyConfig(): ProjectConfig {
    const config: ProjectConfig = {
      provider: 'alpha solutions - 2022',
      attributes: {
        point: [],
        segment: [],
        suppl: []
      },
      prices: [
        {
          alias: 'Labor',
          format: 'money',
          name: 'labor',
          units: 'USD',
          entry:true,
          availability:['point','segment']
        }, {
          alias: 'Materials',
          format: 'money',
          name: 'materials',
          units: 'USD',
          entry:true,
          availability:['point','segment']
        }, {
          alias: 'Length',
          format: '%s feet',
          name: '_length',
          units: 'feet',
          entry:false,
          availability:['point','segment','suppl']
        }, {
          alias: 'Total Cost',
          format: 'money',
          name: '_cost',
          units: 'USD',
          entry:false,
          availability:['suppl']
        }
      ],
      presets: {point:[],segment:[]},
      general: {
        name: '',
        location: {
          lng: 0,
          lat: 0,
          zoom: 15
        }
      }
    };
    return config;
  }
  constructor() {
    this.idMgr = new IDManager();

  }
  Reset() {
    this.idMgr.Reset();
  }
  FromRCCFG(data: any, options: ConfigOptions): ProjectConfig {
    if (!data.provider) {
      return this.FromLegacy(data, options);
    }
    return data as ProjectConfig;
  }
  FromLegacy(data: any, options: ConfigOptions): ProjectConfig {
    const lookup: any = {
      point: {},
      segment: {},
      suppl: {}
    }
    const config: ProjectConfig = (!!options.config) ? options.config : ProjectConfigUtil.MakeEmptyConfig();
    if (options.attributes === true) {
      if (!!data.fields) {
        if (!!data.fields.point) {
          config.attributes.point = [];
          for (const point of data.fields.point) {
            const attribute = this.LegacyFieldToAttribute(point, lookup, 'point');
            config.attributes.point.push(attribute);
          }
        }
        if (!!data.fields.segment) {
          config.attributes.segment = [];
          for (const segment of data.fields.segment) {
            const attribute = this.LegacyFieldToAttribute(segment, lookup, 'segment');
            config.attributes.segment.push(attribute);
          }
        }
      }

    }
    if (options.supplemental) {
      for (const suppl of data.suppl_fields) {
        config.attributes.suppl = [];
        const attribute = this.LegacyFieldToAttribute(suppl, lookup, 'suppl');
        config.attributes.suppl.push(attribute as SupplementalAttribute);
      }
    }
    return config;
  }
  LegacyFieldToAttribute(field: any, lookup: any, target: AttributeFeatureType): ConfigAttribute | SupplementalAttribute {

    let attribute: ConfigAttribute | SupplementalAttribute;
    attribute = {
      id: -2,
      label: '',
      input: 'input',
      calc: 'static',
      displayAlways: true
    };
    if (!!field.type) {
      if (field.type === 'sel') {
        attribute.input = 'selector';
      }
      if (field.type === 'cb') {
        attribute.input = 'checkbox';
      }
      if (field.type === 'text') {
        attribute.input = 'input';
      }
      if (field.type === 'input') {
        attribute.input = 'input';
      }
    }
    let fieldId = field.name;
    let type: IDKeyTypes = 0;
    switch (target) {
      case 'point':
        type = IDKeyTypes.PointAttributes;
        break;
      case 'segment':
        type = IDKeyTypes.SegmentAttributes;
        break;
      case 'suppl':
        type = IDKeyTypes.SupplementalAttributes;
        break;
    }
    if (fieldId && ['segmentType', 'pointType', 'control-point', 'transition-point'].indexOf(field.name) > -1) {
      attribute.id = fieldId;
    } else {
      if (fieldId === -2) {
        fieldId = field.id;
      }
      const id = this.idMgr.ID(type);
      if (id !== undefined) {
        attribute.id = this.idMgr.ID(type);
      }
    }
    if (!!field.calc) {
      attribute.calc = field.calc;
    }
    lookup[target][fieldId] = { attribute: attribute.id, options: [] };
    if (!!field.label) {
      attribute.label = field.label;
    }

    if ((target !== 'suppl') && field.avail_in && field.avail_in !== '*') {
      const availParts = field.avail_in.split('.');
      if (availParts.length > 1) {
        const targetAttName = availParts[0];
        const targetVal = availParts[1];
        const lookupEntry = lookup[target][targetAttName];
        const availIdType = target === 'point' ? IDKeyTypes.PointAttributeCondition : IDKeyTypes.SegmentAttributeCondition;
        if (!!lookupEntry) {
          const ref: AvailCriteria = {
            id: this.idMgr.ID(availIdType),
            type: target,
            comparison: ComparisonKeys.Equals,
            attribute_id: lookup[target][availParts[0]].attribute,
          }
          const entryOptions = lookupEntry?.options;
          if (!!entryOptions) {
            let match = false;
            for (const opt of entryOptions) {
              if (opt.label === targetVal) {
                ref.option_id = opt.id;
                match = true;
                break;
              }
            }
            if (match === true) {
              attribute.availability = [ref];
              attribute.displayAlways = false;
            }
          } else {
            ref.value = targetVal;
            attribute.availability = [ref];
            attribute.displayAlways = false;
          }

        }
      }
    }

    if (!!field.options) {
      attribute.options = [];

      for (const option of field.options) {
        const attOption: AttributeOption = {
          id: this.idMgr.ID(IDKeyTypes.AttributeOption),
          label: option.label
        }
        if (option.metrics) {
          attOption.cost = option.metrics;
        }
        if (option.style) {
          attOption.style = option.style;
        }
        if (!!field.default) {
          if (field.default === option.label) {
            attribute.default = attOption.id;
          }
        }
        lookup[target][field.name].options.push(attOption);
        attribute.options.push(attOption);
      }
    } else if (field.hasOwnProperty('default')) {
      switch (attribute.input) {
        case 'checkbox':
          const checked = [1, 'true', true].indexOf(field.default) > -1;
          attribute.default = checked;
          break;
        case 'input':
          attribute.default = field.default;
          break;
      }
    }
    return attribute;
  }
}
